module.exports = __webpack_public_path__ + "896fb567311edfaa.svg";